import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import { Container } from '@mui/material';
import StickyHeader from './components/StickyHeader';
import './App.css';
import Footer from './components/Footer';
import ContactUs from './pages/ContactUs';
import NewBookingForm from './pages/NewBookingForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ExtraSafetyMeasures from './pages/ExtraSafetyMeasures';
import GrpBusinessUser from './pages/GrpBusinessUser';
import GrpBusinessUserApp from './pages/GrpBusinessUserApp';
import GrpDriver from './pages/GrpDriver';
import GrpPartnerUserApp from './pages/GrpPartnerUserApp';
import WhyGrp from './pages/WhyGrp';
import GrpPartnerUser from './pages/GrpPartnerUser';
import GrpUser from './pages/GrpUser';
import GrpReferFriend from './pages/GrpReferFriend';
import GrpLastMinuteBooking from './pages/GrpLastMinuteBooking';
import WhyBYD from './pages/WhyBYD';
import { appInsights } from './AppInsights';
import LoginPage from './pages/LoginPage';
import OtpValidationPage from './pages/OtpValidationPage';
import ValidateOTPAndRegisterPage from './pages/ValidateOTPAndRegisterPage';
import UserNextRidesPage from './pages/UserNextRidesPage';
import UserBookingDetailsPage from './pages/UserBookingDetailsPage';
import UserCompletedRidesPage from './pages/UserCompletedRidesPage';
import UserBookingDetailsReadOnly from './pages/UserBookingDetailsReadOnly';
import BookingRequest from './pages/BookingRequest';



const App: React.FC = () => {

  const location = useLocation();

  useEffect(() => {
    const pageStartTime = window.performance.timing.navigationStart;
    const pageEndTime = window.performance.timing.domContentLoadedEventEnd;
    const pageLoadTime = pageEndTime - pageStartTime; // Time it takes to load the page

    // Track page view performance in Application Insights
    appInsights.trackPageViewPerformance({
      name: location.pathname,
      properties: {
        pageLoadTime: pageLoadTime, // You can add custom properties here
      },
    });
    console.log(pageLoadTime)
  }, [location]);

  return (
    <>
      <StickyHeader />
      <div id="main-content" className="App">
        <Container className="container" style={{ padding: 0, maxWidth: 1280 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pune-to-mumbai-airport-cab" element={<Home />} />
            <Route path="/pune-to-csmia-cab" element={<Home />} />
            <Route path="/pune-to-mumbai-cab" element={<Home />} />
            <Route path="/pune/mumbai" element={<Home />} />
            <Route path="/pune/mumbai/cab" element={<Home />} />
            <Route path="/pune/mumbai-cab" element={<Home />} />
            <Route path="/pune/mumbai-airport" element={<Home />} />
            <Route path="/pune/csmia" element={<Home />} />
            <Route path="/pune/dadar" element={<Home />} />
            <Route path="/pune/andheri" element={<Home />} />
            <Route path="/pune/juhu" element={<Home />} />
            <Route path="/pune/andheri-west" element={<Home />} />
            <Route path="/pune/andheri-east" element={<Home />} />
            <Route path="/andheri-east-to-pune" element={<Home />} />
            <Route path="/andheri-west-to-pune" element={<Home />} />               
            <Route path="/dadar-to-pune" element={<Home />} />
            <Route path="/juhu-to-pune" element={<Home />} />
            <Route path="/pune-to-mumbai-airport" element={<Home />} />
            <Route path="/pune-to-csmia" element={<Home />} />
            <Route path="/pune-to-dadar" element={<Home />} />
            <Route path="/pune-to-andheri" element={<Home />} />
            <Route path="/pune-to-juhu" element={<Home />} />
            <Route path="/pune-to-andheri-west" element={<Home />} />
            <Route path="/pune-to-andheri-east" element={<Home />} />
            <Route path="/pune-to-andheri-east-taxi" element={<Home />} />
            <Route path="/pune/t1-mumbai" element={<Home />} />
            <Route path="/pune/t2-mumbai" element={<Home />} />
            <Route path="/pune-to-mumbai-taxi" element={<Home />} />
            <Route path="/pune-to-mumbai-car" element={<Home />} />
            <Route path="/pune-to-mumbai" element={<Home />} />
            <Route path="/pune-to-mumbai-green" element={<Home />} />
            <Route path="/pune-to-mumbai-byd" element={<Home />} />
            <Route path="/pune-to-mumbai-airport-innova" element={<Home />} />
            <Route path="/pune-to-mumbai-innova" element={<Home />} />
            <Route path="/pune-to-mumbai-kia" element={<Home />} />
            <Route path="/pune-to-mumbai-mg" element={<Home />} />
            <Route path="/pune-to-mumbai-electric" element={<Home />} />
            <Route path="/pune-to-mumbai-electric-cab" element={<Home />} />
            <Route path="/pune-mumbai-cab" element={<Home />} />

            <Route path="/mumbai-airport-to-pune-cab" element={<Home />} />
            <Route path="/csmia-to-pune-cab" element={<Home />} />
            <Route path="/mumbai-to-pune-cab" element={<Home />} />
            <Route path="/mumbai-to-pune" element={<Home />} />
            <Route path="/mumbai-to-pune-green" element={<Home />} />
            <Route path="/mumbai-to-pune-byd" element={<Home />} />
            <Route path="/mumbai-to-pune-innova" element={<Home />} />
            <Route path="/mumbai-to-pune-kia" element={<Home />} />
            <Route path="/mumbai-to-pune-mg" element={<Home />} />
            <Route path="/mumbai-to-pune-electric" element={<Home />} />
            <Route path="/mumbai-to-pune-electric-cab" element={<Home />} />

            <Route path="/book-your-green-ride" element={<NewBookingForm />} />
            <Route path="/book-now" element={<NewBookingForm />} />
            <Route path="/pune-t2" element={<Home />} />
            <Route path="/pune-mumbai" element={<Home />} />
            <Route path="/t2-pune" element={<Home />} />
            <Route path="/t1-pune" element={<Home />} />
            <Route path="/book" element={<NewBookingForm />} />
            <Route path="/last-minute-booking" element={<NewBookingForm />} />

            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/extra-safety" element={<ExtraSafetyMeasures />} />
            <Route path="/grp-business-users" element={<GrpBusinessUser />} />
            <Route path="/grp-business-user-app" element={<GrpBusinessUserApp />} />
            <Route path="/grp-drivers" element={<GrpDriver />} />
            <Route path="/grp-partner-users" element={<GrpPartnerUser />} />
            <Route path="/grp-partner-user-app" element={<GrpPartnerUserApp />} />
            <Route path="/grp-users" element={<GrpUser />} />
            <Route path="/why-grp" element={<WhyGrp />} />
            <Route path="/why-byd" element={<WhyBYD />} />
            <Route path="/refer-friend" element={<GrpReferFriend />} />
            <Route path="/booking/:bookingId" element={<BookingRequest />} />
            <Route path="/booking-request/:bookingId" element={<BookingRequest />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/OtpValidationPage" element={<OtpValidationPage />} />
            <Route path="/validateAndRegister" element={<ValidateOTPAndRegisterPage />} />
            <Route path="/userNextRidesPage" element={<UserNextRidesPage />} />
            <Route path="/userBookingDetailsPage" element={<UserBookingDetailsPage />} />
            <Route path="/userCompletedRidesPage" element={<UserCompletedRidesPage />} />
            <Route path="/userBookingDetailsReadOnly" element={<UserBookingDetailsReadOnly />} />
          </Routes>
        </Container>
        <Footer />
      </div>
    </>
  );
};

export default App;
